import {
    IImageProps,
    IStackTokens,
    Image,
    PrimaryButton,
    Stack,
    Text,
} from '@fluentui/react';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { routeKeys } from '../../../Common/util/RouteUtils';
import { useIsMobile } from '../../../Common/hooks/useIsMobile';

interface IHomeHeroSectionProps {}

export const HomeHeroSection: React.FC<IHomeHeroSectionProps> = (
    props: IHomeHeroSectionProps
) => {
    const sectionStackTokens: IStackTokens = { childrenGap: 10 };
    const isMobile = useIsMobile();
    const history = useHistory();

    const imageProps: Partial<IImageProps> = {
        src: process.env.PUBLIC_URL + '/abLogo_cropped.svg',
    };

    return (
        <Stack horizontalAlign="center" verticalAlign="center" horizontal>
            {!isMobile && (
                <Image
                    {...imageProps}
                    alt="Sovereign Release Manager"
                    width={200}
                    height={200}
                />
            )}

            <Stack
                tokens={sectionStackTokens}
                style={{
                    width: !isMobile ? '25%' : '100%',
                }}
            >
                <Text variant="xxLarge">Sovereign Release Manager</Text>
                {!isMobile && (
                    <Text variant="small">
                        Providing a comprehensive platform for tracking releases
                        and deployments. We strive to empower teams with the
                        tools they need to streamline their release processes,
                        increase visibility and collaboration, and ultimately
                        deliver high-quality software to their customers faster
                        and more efficiently.
                    </Text>
                )}
                {/* Use a single interactive element (button) and navigate via history to avoid
                    a nested <a> inside <button> (invalid HTML and ambiguous for assistive tech). */}
                <PrimaryButton
                    text="See All Releases"
                    style={{
                        padding: '20px',
                    }}
                    onClick={() =>
                        history.push(routeKeys.Features.Releases.Latest)
                    }
                />
            </Stack>
        </Stack>
    );
};
